/*
 * Public API Surface of ng2-select2-bootstrap
 */

export * from './lib/service/select.service';
export * from './lib/directive/hidden.directive';
export * from './lib/directive/highlight.directive';
export * from './lib/directive/infinite-scroll.directive';
export * from './lib/directive/inner-template.directive';
export * from './lib/component/multiple.component';
export * from './lib/component/request.component';
export * from './lib/component/request-multiple.component';
export * from './lib/component/select.component';
export * from './lib/component/tag.component';
export * from './lib/common/select';
export * from './lib/module';
